<template lang="pug">
  form.feature-update(@submit.prevent="updateBoard")
    .form-field
      label
        //-h6 Move
        .form-field-select
          SelectInput(
            header="Change Board",
            :options="boards",
            label="name",
            :disabled="feature.isReadOnly",
            v-model="assignedBoard._id",
            @change="setMove"
          )
    .status-details(v-if="showUpdateMove")
      .form-field
        textarea(v-model="assignedBoard.comment", placeholder="Comment")
      .form-field
        SubmitButton(label="Submit", :formState="assignState")
        button.button.button-none(type="button", @click="reset") Cancel
</template>

<script>

import { mapState } from 'vuex'
import SelectInput from '@/components/helpers/SelectInput'

export default {
  name: 'FeatureMove',
  components: {
    SelectInput
  },
  props: {
    featureBoard: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      showUpdateMove: false,
      assignState: 'initial',
      assignedBoard: {
        _id: null,
        comment: ''
      }
    }
  },
  mounted () {
    //console.log(this.featureBoard)
    this.assignedBoard._id = this.featureBoard._id
  },
  computed: {
    ...mapState({
      boards: state => state.boards.list,
      feature: state => state.features.selected
    })
  },
  methods: {
    reset () {
      this.showUpdateMove = false
      this.assignedBoard = {
        _id: this.featureBoard._id,
        comment: ''
      }
    },
    setMove () {
      this.showUpdateMove = true
    },
    updateBoard () {
      let update = {
        slug: this.feature.slug,
        update: {
          board: this.assignedBoard._id,
          comment: this.assignedBoard.comment
        }
      }
      this.$store.dispatch('features/updateBoard', update)
        .then(() => {
          this.$router.push({name: 'AdminBoard'})
        })
    },
  }
}
</script>

<style scoped lang="stylus">
.feature-update
  margin-bottom $spacing-3
  .form-field
    margin-bottom $spacing


</style>
